import { useQuery } from 'react-query'
import { API } from './api'

export function useActionDataAPICall(name: string) {
  return useQuery(name, () => API.getActionData())
}

